import { callAPI } from "@/api/httpservice";
import { useEditorStore } from "@/stores/editorStore";
import type { EditorResponse } from "@/types/file.types";
import { serverUrls } from "@/utils/constants";
import { getAuthToken } from "./auth.service";

export function getEditorFiles(errorId:string) {
  return callAPI<EditorResponse>("GET", `/files-errors/${errorId}`, null);
}

export function resolveFileError(fileErrorId:string){
  return callAPI<void>("PATCH", `/files-errors/${fileErrorId}/resolve`, null);
}

export function sendEditorFile(file: any, envelopeId: string) {
  return new Promise((resolve, reject) => {
    const editorStore = useEditorStore();
    const token = getAuthToken();
    if (!token) {
      return false;
    }
    if (token) {
      const xhr = new XMLHttpRequest();
      xhr.addEventListener("load", () => {
        if (xhr.status >= 200 && xhr.status < 300) {
          resolve({ status: xhr.status, body: xhr.responseText });
        } else {
          reject(new Error("Request failed with status: " + xhr.status));
        }
      });
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          editorStore.progress = Math.round((event.loaded / event.total) * 100);
        }
      };
      xhr.addEventListener("error", () =>
        reject(new Error("File upload failed"))
      );
      xhr.addEventListener("abort", () =>
        reject(new Error("File upload aborted"))
      );
      xhr.open(
        "POST",
        `${serverUrls.authUrl + "/files-errors/" + envelopeId}`,
        true
      );
      xhr.setRequestHeader("Authorization", "Bearer " + token);
      xhr.setRequestHeader("Accept", "application/json");
      xhr.setRequestHeader("Access-Control-Allow-Origin", "*");
      const formData = new FormData();
      formData.append("file", file);
      xhr.send(formData);
    }
  });
}

export function leaveEdition(envId:string){
    return callAPI<void>("PATCH", `/envelopes/${envId}/leave-edition`, null);
}